<template>
  <div>
    <page-header-custom-nav v-if="!isNativeAppRequest" />
    <div class="consumerHelpApp">
      <div v-if="$route.name !== 'PageNotFound'">
        <user-message :locale="appLocale" data-test="userMessage" />
        <!-- [Below avoids reload on navigation `/help` & `/help/other-questions`]  -->
        <!-- Featured Articles -->
        <div
          v-if="isPersonalisationRoute($route.name) && !personalisationEnabled"
          class="l-container c-featArticlesContainer"
        >
          <div class="l-container--inner c-featArticlesContainer">
            <div>
              <non-personalised-page-heading v-once />
              <featured-articles :feat-articles="featuredArticles" />
            </div>
          </div>
        </div>
        <!-- Personalisation -->
        <personalised-help
          v-if="isPersonalisationRoute($route.name) && personalisationEnabled"
          v-once
        />
      </div>
      <!-- Route -->
      <router-view />
    </div>
    <page-footer v-if="!isNativeAppRequest" :locale="appLocale" :content="footerContent" />
    <vue-cookie-banner v-if="(!isNativeAppRequest)" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserMessage from '@justeat/f-user-message'
import PageHeaderCustomNav from './components/PageHeaderCustomNav.vue'
import PersonalisedHelp from './components/PersonalisedHelp.vue'
import NonPersonalisedPageHeading from './components/NonPersonalisedPageHeading.vue'
import FeaturedArticles from './components/FeaturedArticles.vue'
import ConfigService from './services/ConfigService'
import logger from './utilities/logger'

import './styles/index.scss'
import '@justeat/f-header/dist/f-header.css'
import '@justeat/f-user-message/dist/f-user-message.css'
import '@justeat/f-footer/dist/f-footer.css'

export default {
  name: 'HelpApp',
  components: {
    PageHeaderCustomNav,
    PageFooter: () => import(/* webpackChunkName: "vue-footer" */ '@justeat/f-footer'),
    UserMessage,
    VueCookieBanner: () => import(/* webpackChunkName: "vue-cookie-banner" */ './components/VueCookieBanner.vue'),
    PersonalisedHelp,
    NonPersonalisedPageHeading,
    FeaturedArticles
  },
  computed: {
    ...mapGetters([
      'appLocale',
      'personalisationEnabled',
      'featuredArticles',
      'footerContent',
      'isNativeAppRequest',
      'tenant',
      'userInfoData'
    ])
  },
  created() {
    this.$store.dispatch('fetchLocale')
    this.$store.dispatch('snowplow/setGlobalContext', this.$route.name)
    this.$store.dispatch('fetchArticles', this.$auth)
    this.$store.dispatch('fetchFooterContent', this.$auth)
    if (!ConfigService.personalisationEnabled()) {
      // Content required by personalisation fallabck
      this.$store.dispatch('useFallbackForTopLevelActions')
    }

    logger.info('Application loaded')
  },
  methods: {
    isPersonalisationRoute(route) {
      return route === 'help' || route === 'other-questions'
    },
    displayPersonlisationFallback(route) {
      return route === 'help' || route === 'other-questions'
    }
  }
}
</script>
